export default __webpack_public_path__ + "static/media/aaron.b8267651.jpg";